import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import {RouteInfo} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import {css} from "@emotion/css";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {useEffect, useState} from "react";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {MultiMediaService} from "./MultiMediaService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbar} from "notistack";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import RaikoCustomTable from "../../raikoComponents/raikoCustomTable/RaikoCustomTable";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import RaikoCustomSimpleActiveDeActiveChip
    from "../../raikoComponents/raikoCustomChip/raikoCustomSimpleActiveDeactiveChip/RaikoCustomSimpleActiveDeActiveChip";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {navigate} from "@storybook/addon-links";
import {useNavigate} from "react-router-dom";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import MultiMediaAddNewItem from "./MultiMediaAddNewItem";

export default function MultiMediaList() {

    let page = 0;
    const size = 15;

    const service = new MultiMediaService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const navigate = useNavigate()

    const [addDialogOpenState, setAddDialogOpenState] = useState(false);

    useEffect(()=>{
       getDataFromServer()
    },[])

    function prepareTableRow(id, number, title, creator, publishedDate, publishedState, url) {
        return {
            id,
            number,
            title,
            creator,
            publishedDate: convertUniversalDateToPersianDate(publishedDate),
            publishedState: <RaikoCustomSimpleActiveDeActiveChip
                deActiveStateTitle={"منتشر نشده"}
                activeStateTitle={"منتشر شده"}
                state={publishedState}/>
        }
    }

    const [tableList, setTableList] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function handleSelectRow(rowId) {
        navigate(RouteInfo.MultiMediaDetail.globalUrl.replace(":id", rowId))
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getDataFromServer(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setTableList([])
                response.data.map((item, index) => {
                    setTableList(prevState => [
                        ...prevState,
                        prepareTableRow(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.createdBy,
                            item.createdAt,
                            false,
                            item.thumbnail.url
                        )
                    ])
                })

                setTableLoading(false)
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت لیست ویدیو ها"))
            setTableLoading(false)
        })
    }

    function closeAddDialog() {
        setAddDialogOpenState(false)
    }

    function openAddDialog() {
        setAddDialogOpenState(true)
    }

    function handleAddNewItemToTable(newItem) {
        if (page === 0) {
            const _items = tableList
            setTableList([prepareTableRow(
                newItem.id,
                1,
                newItem.title,
                newItem.createdBy,
                newItem.createdAt,
                false,
                ""
            )])
            if (_items.length > 0) {
                _items.map((item, index) => {
                    setTableList(prevState => [
                        ...prevState,
                        {
                            ...item,
                            number: (page * size) + index + 2
                        }
                    ])
                })
            }
        }
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.MultiMediaList.name}</title>
            </Helmet>

            <RaikoDefaultDialogPage
                onClose={closeAddDialog}
                open={addDialogOpenState}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"افزودن ویدیو جدید"}
            >
                <MultiMediaAddNewItem handleAddNewItem={handleAddNewItemToTable} handleCloseDialog={closeAddDialog}/>
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoBreadcrumb
                    breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            "چندرسانه ای",
                            ""
                        ),
                        raikoBreadCrumbItemGenerator(
                            RouteInfo.MultiMediaList.name,
                            RouteInfo.MultiMediaList.globalUrl
                        ),
                    ]}
                />
                <RaikoBaseCardContainer className={css`margin-top: 40px`}>
                    <RaikoGridOneColumn>
                        <ButtonDivisionSection>
                            <ButtonPrimaryRaiko
                                label={"افزودن"}
                                className={css`
                                  height: max-content !important;
                                `}
                                onClick={openAddDialog}
                            />
                        </ButtonDivisionSection>
                        <RaikoCustomTable
                            isLoading={tableLoading}
                            data={tableList}
                            header={columns}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleSelectRow}/>

                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>
        </>
    )
}


const columns = [
    {
        id: 'number',
        label: '#'
    }, {
        id: 'title',
        label: 'عنوان'
    }, {
        id: 'creator',
        label: 'سازنده',
    }, {
        id: 'publishedDate',
        label: 'تاریخ ساخت',
    }, /*{
        id: 'publishedState',
        label: 'وضعیت انتشار',
    },*/
];